import CloudStorage from "../../../CloudStorage/CloudStorage";
import { useTranslation } from "react-i18next";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FilterPostListings } from "../../../redux/posts/action";
import { useNavigate } from "react-router-dom";
import { decodeHtml } from "../../../assests/extention/commonfunction";

export default function GlobalSearch() {
  const { t } = useTranslation();
  const laung = localStorage.getItem("laung");
  const [lan] = useState(laung ?? "en");
  const [selectUser, setselectUser] = useState("");
  const [searchtext, setSearchtext] = useState("");
  const [debouncedSearchtext, setDebouncedSearchtext] = useState("");
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const wrapperRef = useRef(null);

  const getpostlist = useSelector(
    ({ posts: { getfilterdpost } }) => getfilterdpost?.response || []
  );

  // Debounce search input
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedSearchtext(searchtext), 500);
    return () => clearTimeout(handler);
  }, [searchtext]);

  // Fetch filtered posts
  useEffect(() => {
    if (debouncedSearchtext?.length > 0) {
      const data = {
        method: "GET",
        index: 0,
        size: "10",
        search: debouncedSearchtext,
      };
      dispatch(FilterPostListings(data));
      setModal(true);
    } else {
      setModal(false);
    }
  }, [debouncedSearchtext, dispatch]);

  // Click outside to close
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setModal(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const navigatetopost = (item) => {
    const typeRoutes = {
      "1": "projectdetails",
      "2": "contestdetails",
      "3": "jobdetails",
      "4": "umbrelladetails",
    };
    const route = typeRoutes[item?.type] || "projectdetails";
    navigate(`/${lan}/${route}/${item?.id}`);
    setModal(false);
  };

  const clearSearch = () => {
    setSearchtext("");
    setModal(false);
  };

  return (
    <div ref={wrapperRef} className={`active-drop ${modal ? "active" : ""}`}>
      <div className="search-bar">
        <input
          type="search"
          value={searchtext}
          onChange={(e) => setSearchtext(e.target.value)}
          placeholder={t("Search Here")}
          className="form-control"
        />
        {/* {searchtext && (
          <button style={{paddingRight:50}} className="btn clear-btn" onClick={clearSearch}>
            ✕
          </button>
        )} */}
        <button className="btn search-btn">
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/search-btn.svg`}
            alt=""
          />
        </button>
      </div>

      {modal && (
        <div className="nav-drop">
          {getpostlist?.length > 0 ? (
            getpostlist?.map((item, index) => (
              <div
                key={index}
                className="message-box"
                onClick={() => {
                  setselectUser(item);
                  navigatetopost(item);
                }}
                style={{
                  background:
                    (selectUser?.user_id || selectUser?.id) ===
                    (item?.user_id || item?.id)
                      ? "#f5f5f5"
                      : "",
                }}
              >
                <div className="messagebox-left">
                  <img width={30} src={item?.profile_image} alt="" />
                  <div>
                    <h6>{decodeHtml(item?.title)}</h6>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-results">
              <p>{t("No results found")}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
